import { db } from "../../index";
import { UserContext } from "../../App";
import { useContext, useEffect, useState } from "react";

export function useProviderOptions(
  allOption = false,
  allOptionsLabel = "Tous les clients",
  reloadToken = 0
) {
  const { userInfos } = useContext(UserContext);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    async function getData() {
      const snapshot = await db
        .ref(`users/${userInfos.uid}/provider`)
        .once("value");

      let res = [];

      snapshot.forEach(function (childSnapshot) {
        if (userInfos?.child?.rights?.providersFilter?.length) {
          if (
            !userInfos.child.rights.providersFilter.includes(childSnapshot.key)
          ) {
            return;
          }
        }
        res.push({
          value: childSnapshot.key,
          label: childSnapshot.val().name,
          data: {
            ...childSnapshot.val(),
            key: childSnapshot.key,
          },
        });
      });

      res.sort((a, b) => {
        try {
          if (a.label.toUpperCase() < b.label.toUpperCase()) {
            return -1;
          }
          if (a.label.toUpperCase() > b.label.toUpperCase()) {
            return 1;
          }
        } catch (e) {
          return 0;
        }
        return 0;
      });

      if (allOption && !userInfos?.child?.rights?.providersFilter?.length) {
        res.unshift({
          value: null,
          label: allOptionsLabel,
          data: null,
        });
      }

      setOptions(res);
    }

    if (userInfos.uid) getData().then();
  }, [allOption, allOptionsLabel, reloadToken, userInfos]);
  return options;
}

export const searchProviderAsync = (uid, name) => {
  let options = [];

  return new Promise((resolve) => {
    let providerRef = db
      .ref(`users/${uid}/provider`)
      .orderByChild("name")
      .startAt(name)
      .endAt(name + "\uf8ff");
    providerRef.once("value").then((snapshot) => {
      snapshot.forEach(function (childSnapshot) {
        options.push({
          value: childSnapshot.key,
          label: childSnapshot.val().name,
          data: {
            ...childSnapshot.val(),
            key: childSnapshot.key,
          },
        });
      });

      resolve(options);
    });
  });
};
